export default function Stars() {
  const starFields = ['Small', 'Medium', 'Large'];
  const shootingStarCount = 12;

  const stars = document.createElement('div');
  stars.classList.add('Stars');

  starFields.forEach((field) => {
    stars.appendChild(buildStarField(field));
  });

  for (let i = 1; i <= shootingStarCount; i++) {
    stars.appendChild(buildShootingStar(i));
  }

  return stars;
}

function buildStarField(field) {
  const starField = document.createElement('div');
  starField.classList.add('StarField', `StarField--size${field}`);

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '100%');
  svg.setAttribute('height', '100%');

  const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
  rect.setAttribute('width', '100%');
  rect.setAttribute('height', '100%');
  rect.setAttribute('fill', `url(#Stars${field}Pattern)`);

  svg.appendChild(rect);
  starField.appendChild(svg);

  return starField;
}

function buildShootingStar(index) {
  const shootingStar = document.createElement('div');
  shootingStar.classList.add('ShootingStar', `ShootingStar--index${index}`);

  return shootingStar;
}
